import React from "react";
import getNameFromUrl from "../../utils/getNameFromUrl";
import "./index.less";
export default ({ value = [] }) => (
  <span className="TUI-FileList">
    {value.map(v =>
      typeof v === "object" ? (
        <a key={v.url} target="_blank" href={v.url}>
          {getNameFromUrl(v.url)}
        </a>
      ) : (
        <a key={v} target="_blank" href={v}>
          {getNameFromUrl(v)}
        </a>
      )
    )}
  </span>
);
